import React from 'react';

interface ImportExportDialogProps {
  isOpen: boolean;
  importExportText: string;
  onTextChange: (text: string) => void;
  onClose: () => void;
  onImport: () => void;
}

export function ImportExportDialog({
  isOpen,
  importExportText,
  onTextChange,
  onClose,
  onImport,
}: ImportExportDialogProps) {
  if (!isOpen) return null;

  const isExporting = importExportText && importExportText.startsWith('{');
  const isImporting = importExportText && !importExportText.startsWith('{');

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(importExportText);
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        width: '600px',
        maxWidth: '90vw',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <h3 style={{ margin: '0 0 15px 0' }}>
          {isExporting ? 'Export Grid State' : 'Import Grid State'}
        </h3>
        
        <textarea
          value={importExportText}
          onChange={(e) => onTextChange(e.target.value)}
          placeholder="Paste your JSON here to import a grid state..."
          style={{
            flex: 1,
            minHeight: '300px',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontFamily: 'monospace',
            fontSize: '12px',
            resize: 'vertical'
          }}
        />
        
        <div style={{
          marginTop: '15px',
          display: 'flex',
          gap: '10px',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              background: '#f0f0f0',
              border: '1px solid #ccc',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          
          {isExporting && (
            <button
              onClick={handleCopyToClipboard}
              style={{
                padding: '8px 16px',
                background: '#2196F3',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Copy to Clipboard
            </button>
          )}
          
          {isImporting && (
            <button
              onClick={onImport}
              style={{
                padding: '8px 16px',
                background: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Import
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
